import { Box } from "@mui/material";
import "./styles/Principal.css"
import PrincipalPageDrawer from "./components/PrincipalPageDrawer/PrincipalPageDrawer";
import PrincipalPageFooter from "./components/PrincipalPageFooter/PrincipalPageFooter";
import PrincipalPageNavigation from "./navigations/PrincipalPageNavigation";
import { Outlet,useNavigate } from "react-router-dom";
import { PrincipalPageProvider, usePrincipalPage } from "../../context/PrincipalPageContext/PrincipalPageContext";
import IconNavigation from "../../components/composed-styled-components/InconNavigation/InconNavigation";
import { useAuth } from "../../context/AuthContext/AuthContext"
import { useEffect, useState } from "react"
import MessageDialog from "../../components/composed-styled-components/MessageDialog/MessageDialog"

const PrincipalPageContent = () => {
    const { isMenuOpen } = usePrincipalPage();

    return (
        <Box>
            <PrincipalPageDrawer />
            <Outlet />
            <PrincipalPageNavigation />
            <PrincipalPageFooter />
            {!isMenuOpen && <IconNavigation />}
        </Box>
    );
};

const PrincipalPage = () => {
    const [openMesssage, setOpenMessage] = useState({ state: false, message: "" })
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Safety net: if a Modal/Drawer left the page scroll-locked, restore it for the principal page.
        // This fixes cases where wheel/touch scrolling stops working but the scrollbar still appears.
        const html = document.documentElement;
        const body = document.body;

        const prev = {
            htmlOverflow: html.style.overflow,
            htmlOverflowY: html.style.overflowY,
            htmlTouchAction: html.style.touchAction,
            bodyOverflow: body.style.overflow,
            bodyOverflowY: body.style.overflowY,
            bodyTouchAction: body.style.touchAction,
        };

        html.style.overflowY = "auto";
        body.style.overflowY = "auto";
        html.style.touchAction = "auto";
        body.style.touchAction = "auto";

        return () => {
            html.style.overflow = prev.htmlOverflow;
            html.style.overflowY = prev.htmlOverflowY;
            html.style.touchAction = prev.htmlTouchAction;
            body.style.overflow = prev.bodyOverflow;
            body.style.overflowY = prev.bodyOverflowY;
            body.style.touchAction = prev.bodyTouchAction;
        };
    }, []);

    useEffect(()=>{
        if(user?.lifeToken){
           const expirationDate = new Date(user?.lifeToken.replace("Z", ""));
           const now = new Date();
           if (expirationDate < now) {
              setOpenMessage({state:true,message:"La autenticacion ha expirado"});
              setTimeout(()=>{ logout(()=>{navigate("/Login")})},2000)
           } 
        }
      },[user]);

    return (<>
        <MessageDialog open={openMesssage.state} onClose={() => setOpenMessage({ state: false, message: "" })} message={openMesssage.message} />
        <PrincipalPageProvider>
            <PrincipalPageContent />
        </PrincipalPageProvider>
    </>)
}

export default PrincipalPage;
